import React from 'react';
import { Box, Heading } from '@hover/blueprint';
import JobBenefit from './JobBenefit';
import { JOB_POSTS_BENEFITS } from '../../../constants';
import { IJobPostsBenefit } from '../../../interfaces/IJobPostsBenefit';

const JobPostsBenefits: React.FC = () => (
  <Box flexDir="column" mt={{ base: 600, tablet: 800 }}>
    <Heading
      marginBottom={{ base: 0, tablet: 0 }}
      size={{ tablet: 500, desktop: 600 }}
    >
      Benefits
    </Heading>
    {JOB_POSTS_BENEFITS.map((jobBenefit: IJobPostsBenefit) => (
      <JobBenefit
        key={jobBenefit.id}
        iconName={jobBenefit.icon}
        title={jobBenefit.title}
        body={jobBenefit.body}
      />
    ))}
  </Box>
);

export default JobPostsBenefits;
